import { render, staticRenderFns } from "./NewAddOTPComponent.vue?vue&type=template&id=4fa5d851&scoped=true"
import script from "./NewAddOTPComponent.vue?vue&type=script&lang=js"
export * from "./NewAddOTPComponent.vue?vue&type=script&lang=js"
import style0 from "./NewAddOTPComponent.vue?vue&type=style&index=0&id=4fa5d851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa5d851",
  null
  
)

export default component.exports